let gqlUrl: string = undefined

export const configureDirectoryClient = (url: string): void => {
  gqlUrl = url
}

export const graphUrl = () => gqlUrl